import { get } from 'lodash';
import { images as iK } from 'src/tools/contentModulesFieldName';
import arrayMove from 'array-move';
import { generateResponsiveImage } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/generator';

const useImageCarousel = ({ form }) => {
  const handleOnModalConfirm = (data) => {
    const draggableId = get(data, 'draggableId');
    const images = form.getFieldValue(iK) || [];
    const nI = images.map((i) => {
      const iD = get(i, 'draggableId');
      if (iD === draggableId) {
        return { ...(i || {}), ...data };
      } else {
        return i;
      }
    });

    form.setFieldsValue({ [iK]: nI });
  };
  const handleOnAdd = (value, onChange) => {
    const pc = generateResponsiveImage();
    //const { pc } = ;
    onChange([...(value || []), pc]);
  };
  const handleOnDelete = (value, onChange, index) => {
    const nValue = (value || []).filter((_, i) => {
      return i !== index;
    });
    onChange(nValue);
  };
  const handleOnSort = (value, onChange, from, to) => {
    const nValue = arrayMove(value || [], from, to);
    onChange(nValue);
  };
  return { handleOnModalConfirm, handleOnAdd, handleOnDelete, handleOnSort };
};
export { useImageCarousel };
